// Styles for PhoneNumberField go here.
import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';
import { constants } from '../../modules';

export const StyledPhoneNumberField = styled.div`
  .dropdown-field {
    width: 30%;
    position: relative;
  }
  .blurred {
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 125%;
    opacity: 0.5;
    background-color: ${baseVariables.color['base20']};
    top: ${toRem(-10)};
  }
  .inputtext-field {
    flex: 1;
    input {
      caret-color: ${baseVariables.color['neutral40']};
    }
  }
  .country-label {
    z-index: 1;
  }
  .country-code-dropdown {
    width: 100%;

    &_standard {
      border-color: ${baseVariables.color['base10']} !important;
      border-radius: ${toRem(4)} !important;
      height: ${toRem(45)};
      &:is(${constants.NOTO_SANS_LANG_LIST}) {
        height: ${toRem(48.98)};
      }
      &:is(${constants.ARABIC_LANG}) {
        height: ${toRem(55.33)};
      }
      &:is(${constants.HEBREW_LANG}) {
        height: ${toRem(41.33)};
      }
    }
  }
  .country-code-dropdown.is-disabled {
    border-color: ${baseVariables.color['neutral40']} !important;
  }
  .country-code-dropdown .icon-dropdown-down,
  .country-code-dropdown .icon-dropdown-up {
    position: absolute;
    right: ${toRem(8)} !important;
  }
  .numberfieldwidth {
    max-width: 90%;
  }
  .phonenumber-standard {
    .dropdown-standard {
      border-radius: ${toRem(8)} !important;
      border: ${baseVariables.color['neutral30']} solid ${toRem(1)} !important;
      line-height: ${toRem(24)};
      padding: ${toRem(20)} ${toRem(16)} ${toRem(10)} !important;
      height: ${toRem(52)};
    }
  }
  .dropdown__label {
    left: ${toRem(26)};
    @media ${baseVariables.mediaQuery.md} {
      left: ${toRem(30)};
    }
  }
`;
